import { render, staticRenderFns } from "./MenuOnly.vue?vue&type=template&id=f799c9d8&scoped=true&"
import script from "./MenuOnly.vue?vue&type=script&lang=js&"
export * from "./MenuOnly.vue?vue&type=script&lang=js&"
import style1 from "./MenuOnly.vue?vue&type=style&index=1&lang=css&"
import style2 from "./MenuOnly.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f799c9d8",
  null
  
)

export default component.exports